import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["innerHTML"];
import { computed } from "vue";
import DOMPurify from "dompurify";
import { useDonation } from "../../context/donationContext";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LegalNotice',
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        const { legalNotice } = useDonation();
        function isBlankHtml(html) {
            // Character-for-character copy of the admin editor's isBlankHtml: change both together.
            // prettier-ignore
            return html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim() === "";
        }
        const noticeHtml = computed(() => {
            const fragment = DOMPurify.sanitize(legalNotice.value, { RETURN_DOM_FRAGMENT: true });
            fragment.querySelectorAll("a[href]").forEach((anchor) => {
                anchor.setAttribute("target", "_blank");
                anchor.setAttribute("rel", "noopener noreferrer");
            });
            const host = document.createElement("div");
            host.append(fragment);
            return host.innerHTML;
        });
        const hasNotice = computed(() => !isBlankHtml(noticeHtml.value));
        return (_ctx, _cache) => {
            return (hasNotice.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "df-legal",
                    innerHTML: noticeHtml.value
                }, null, 8 /* PROPS */, _hoisted_1))
                : _createCommentVNode("v-if", true);
        };
    }
});
